import RadioButtonsGroup from '../radio-button/RadioButtonsGroup';

import styles from './Users.module.scss';

const UsersAssignedFilter = ({ value, cb }) => {
  const options = [
    { value: 'all', label: 'All' },
    { value: 'unassigned', label: 'Unassigned' },
    { value: 'assigned', label: 'Assigned' },
  ];

  return (
    <div className={styles['users-control-filter']}>
      <RadioButtonsGroup
        label="Show:"
        defaultValue="unassigned"
        value={value}
        buttons={options}
        onChange={cb}
      />
    </div>
  );
};

export default UsersAssignedFilter;
